"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "villa-santa-lucia": {
    "d7d379e9": [{
      "hkey": "7fd267d2",
      "slug": "villa-santa-lucia",
      "name": "Villa Santa Lucia",
      "primary": true,
      "skipSearch": false
    }],
    "piumarola": [{
      "hkey": "7fd267d2",
      "slug": "villa-santa-lucia",
      "name": "Villa Santa Lucia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;